import useTheme from "../hooks/useTheme";

const UploadIconSvg = ({ color, size }: { color?: string; size?: number }) => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "12"}
      height={size ?? "13"}
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M10.5 8C10.3011 8 10.1103 8.07902 9.96967 8.21967C9.82902 8.36032 9.75 8.55109 9.75 8.75V10.25H2.25V8.75C2.25 8.55109 2.17098 8.36032 2.03033 8.21967C1.88968 8.07902 1.69891 8 1.5 8C1.30109 8 1.11032 8.07902 0.96967 8.21967C0.829018 8.36032 0.75 8.55109 0.75 8.75V10.25C0.75 10.6478 0.908035 11.0294 1.18934 11.3107C1.47064 11.592 1.85218 11.75 2.25 11.75H9.75C10.1478 11.75 10.5294 11.592 10.8107 11.3107C11.092 11.0294 11.25 10.6478 11.25 10.25V8.75C11.25 8.55109 11.171 8.36032 11.0303 8.21967C10.8897 8.07902 10.6989 8 10.5 8Z"
        fill={color ?? "#1064DB"}
      />
      <path
        d="M3.5308 5.53009L5.25055 3.81034V7.99984C5.25055 8.19875 5.32957 8.38952 5.47022 8.53017C5.61087 8.67082 5.80164 8.74984 6.00055 8.74984C6.19946 8.74984 6.39023 8.67082 6.53088 8.53017C6.67153 8.38952 6.75055 8.19875 6.75055 7.99984V3.81034L8.4703 5.53009C8.61175 5.66671 8.8012 5.7423 8.99785 5.7406C9.1945 5.73889 9.38261 5.66001 9.52166 5.52095C9.66072 5.3819 9.7396 5.19379 9.7413 4.99714C9.74301 4.80049 9.66742 4.61104 9.5308 4.46959L6.5308 1.46959C6.39015 1.32899 6.19942 1.25 6.00055 1.25C5.80168 1.25 5.61095 1.32899 5.4703 1.46959L2.4703 4.46959C2.33368 4.61104 2.25809 4.80049 2.25979 4.99714C2.2615 5.19379 2.34038 5.3819 2.47944 5.52095C2.61849 5.66001 2.8066 5.73889 3.00325 5.7406C3.1999 5.7423 3.38935 5.66671 3.5308 5.53009Z"
        fill={color ?? "#1064DB"}
      />
    </svg>
  );
};

export default UploadIconSvg;
